
export function handleTestJourney() {
    setInterval(() => {
        const conv_cvar_10 = window.dataLayer.find((objElement) => objElement.hasOwnProperty('walmeric_test'));
        const conv_cvar_25 = window.dataLayer.findLast((objElement) => objElement.hasOwnProperty('walmeric_journey'));

        if (conv_cvar_10 && conv_cvar_10.walmeric_test != window.c_var_10) {
            window.c_var_10 = conv_cvar_10.walmeric_test;
            womtp.c_vars[10] = conv_cvar_10.walmeric_test;
            DRP.loadLabels(window.userLabels);
        }

        if (conv_cvar_25 && conv_cvar_25.walmeric_journey != window.c_var_25) {
            window.c_var_25 = conv_cvar_25.walmeric_journey;
            womtp.c_vars[25] = conv_cvar_25.walmeric_journey;
            DRP.loadLabels(window.userLabels);
        }

    }, 1500);
}